import axios from 'axios';
import VueCryptojs from 'vue-cryptojs';
import { createApp, markRaw } from 'vue';
import { createPinia } from 'pinia';
import { promptStore } from './stores/prompt';

import App from './App.vue';
import router from './router';

import '../node_modules/vue-multiselect/dist/vue-multiselect.css';
import './styles/styles.css';

const app = createApp(App).use(VueCryptojs);
const pinia = createPinia();
pinia.use(({ store }) => {
    store.$router = markRaw(router);
});

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        //Catch these errors globaly
        if (error.response.status === 500) {
            promptStore().displayErrorMessage(error.response.status, error.response.data.detail);
            return Promise.resolve(error);
        }

        //Pass these errors along
        if (
            error.response.status === 401 ||
            error.response.status === 403 ||
            error.response.status === 404 ||
            error.response.status === 409
        ) {
            return Promise.resolve();
        }

        //Reject all others
        return Promise.reject(error);
    }
);

app.use(router).use(pinia).mount('#app');

//Version
window.version = process.env.BASE_URL.split('/')[3];
